<div *ngIf="showTimer" class="countdown-header" [ngClass]="{'countdown-last-order': isAlert}">
  {{isAlert ? ('time.running.out.last.order' | translate) : ('last.order.in' | translate)}} <span class="timer">
    {{ minutes }}:{{ seconds | number: '2.0' }}</span>
</div>
